import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CoinRub icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CoinRub } from '@sravni/design-system-icons'
 *
 * <CoinRub />
 * ```
 */
var CoinRub = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CoinRub", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.432 14.24a7.244 7.244 0 0 0 0-10.408 7.558 7.558 0 0 0-10.591 0 7.245 7.245 0 0 0 0 10.407M3.554 17.5h13.333H3.554v0ZM10.97 11.666H7.22", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8.636 13.334v-7.5h2.647a1.77 1.77 0 0 1 0 3.54H7.22", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CoinRub };
//# sourceMappingURL=CoinRub.js.map
